import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ImagesOnProduct } from '@app/_models/e-commerce/products/product.model';
import { McToastService } from '@app/_services';
import * as CustomValidators from '@app/_validators';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { UploadPhoto } from '../../store/images.actions';
import { IMAGE_MANAGER_DIALOG_DATA } from '../../img-modal.component';

@Component({
    selector: 'url-upload',
    templateUrl: 'url-upload.component.html',
    styleUrls: ['url-upload.component.scss'],
})
export class UrlUploadComponent implements OnInit {
    @ViewChildren('inputElement') inputElements: QueryList<ElementRef>;
    urlsForm: UntypedFormGroup;
    urlReg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    loading: boolean = false;

    @Input() data: IMAGE_MANAGER_DIALOG_DATA;

    @Output() closeDialog: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private fb: UntypedFormBuilder,
        private toast: McToastService,
        private translate: TranslateService,
        private store: Store
    ) {}

    ngOnInit(): void {
        this.buildForm();
    }

    save() {
        this.loading = true;
        const urls = this.urlsForm.value.urls;
        if (urls[0] === '' || !this.urlsForm.valid) {
            return;
        }

        const formData: FormData = new FormData();

        urls.forEach((urls, index) => {
            formData.append(`data[${index}][file]`, urls);
            formData.append(`data[${index}][relation_id]`, this.data.relation_id.toString());
            formData.append(`data[${index}][module]`, this.data.module);
            formData.append(`data[${index}][type]`, 'image');
            formData.append(`data[${index}][url]`, 'true');
        });

        this.store.dispatch(new UploadPhoto(formData)).subscribe({
            complete: () => (this.loading = false),
        });
    }

    buildForm() {
        this.urlsForm = this.fb.group({
            urls: this.fb.array(this.createUrlControl()),
        });
    }

    get urls() {
        return this.urlsForm.get('urls') as UntypedFormArray;
    }

    createUrlControl() {
        let controls = [];
        controls.push(new UntypedFormControl('', CustomValidators.url()));
        return controls;
    }

    addField() {
        this.inputElements.changes.subscribe(() => {
            this.inputElements.last.nativeElement.focus();
        });
        let addSuccess: boolean = false;
        this.urls.value.forEach((value) => {
            !value ? (addSuccess = false) : (addSuccess = true);
        });
        if (addSuccess && this.urls.status == 'VALID') {
            const imagesQty = this.urls.controls.length;
            if (imagesQty < 15) {
                this.urls.push(this.fb.control('', [CustomValidators.url(), Validators.required]));
            } else {
                this.toast.danger(
                    this.translate.instant(
                        'app.global.modals.image_manager.upload_image_modal.link.errors.images_limit'
                    )
                );
            }
        }
    }

    deleteUrlField(index) {
        if (this.urls.controls.length > 1) {
            const control = <UntypedFormArray>this.urlsForm.controls['urls'];
            control.removeAt(index);
            this.setValidators();
        }
    }

    setValidators() {
        if (this.urls.controls.length == 1) {
            this.urls.controls[0].clearValidators();
            this.urls.controls[0].setValidators([CustomValidators.url()]);
            this.urls.controls[0].updateValueAndValidity();
        }
    }

    cancel(): void {
        if (this.urls.controls.length > 1) {
            const control = <UntypedFormArray>this.urlsForm.controls['urls'];
            control.clear();
            this.urls.push(this.fb.control('', [CustomValidators.url(), Validators.required]));
            this.setValidators();
        } else {
            this.closeDialog.emit(true);
        }
    }
}
